import wordings from '!json-loader!val-loader!./siDefaultWordingsBuilder.js';

export default wordings;
